/**
 * Enumeración que representa las diferentes orientaciones posibles.
 *
 * @enum {string}
 * @property {string} Clasico - Orientación clásica.
 * @property {string} Horizontal - Orientación horizontal.
 * @property {string} Vertical - Orientación vertical.
 * @property {string} Detalle - Orientación de detalle.
 */
export enum Orientation {
  Clasico = "clasico",
  Horizontal = "horizontal",
  Vertical = "vertical",
  Detalle = "detalle",
}
